import { Box, Grid } from "@material-ui/core";
import React from "react";
import ErrorSnackbarHandler from "../../../../ui/components/ErrorSnackbar/ErrorSnackbarHandler";
import NavigationRail, { RailLink } from "../../../../ui/components/NavigationRail";
import SuccessSnackbarHandler from "../../../../ui/components/SuccessSnackbar/SuccessSnackbarHandler";
import { DEFAULT_SPACING, EXTRA_LARGE_SPACING } from "../../../../ui/theme/dimensions";
import ChangePassword from "../model/ChangePassword";
import CurrentUserDetails from "../model/CurrentUserDetails";
import ChangePasswordPanel from "./ChangePasswordPanel";
import BenchmarkAccountPanel from "./BenchmarkAccountPanel";
import UserDetailsPanel from "./UserDetailsPanel";
import BenchmarkAccount from "../model/BenchmarkAccount";
import { isBenchmarkEnabledForCountry } from "../../../../utils/featureConfig";

interface Props {
  pageTitle: string;
  navLinks: RailLink[];
  user: CurrentUserDetails;
  loading: boolean;
  error: string | undefined;
  success: string | undefined;
  onUserUpdated: (user: CurrentUserDetails) => void;
  onPasswordChanged: (password: ChangePassword, message: string) => void;
  onBenchmarkAction?: (action: BenchmarkAccount) => void;
  userOrganisationCountry?: string;
}

const UserPanel = (props: Props) => {
  const isBenchmarkEnabled = isBenchmarkEnabledForCountry(props.userOrganisationCountry);

  return (
    <Box>
      <Box padding={DEFAULT_SPACING} display="flex" justifyContent="space-between">
        <NavigationRail currentPageTitle={props.pageTitle} links={props.navLinks} />
      </Box>
      <Box paddingX={EXTRA_LARGE_SPACING} paddingBottom={DEFAULT_SPACING}>
        <Grid container justify="center">
          <Grid item xs={5}>
            <UserDetailsPanel
              user={props.user}
              loading={props.loading}
              error={props.error}
              onUserUpdated={props.onUserUpdated}
            />  
          </Grid>

          <Grid item xs={5}>
            <ChangePasswordPanel
              loading={props.loading}
              onPasswordChanged={props.onPasswordChanged}
            />
            {isBenchmarkEnabled && (
              <Box marginTop={DEFAULT_SPACING}>
                <BenchmarkAccountPanel
                  loading={props.loading}
                  onBenchmarkAction={props.onBenchmarkAction}
                  isLinked={props.user.benchmark_engineer_uuid !== null && props.user.benchmark_engineer_uuid !== undefined}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>

      <ErrorSnackbarHandler message={props.error} />
      <SuccessSnackbarHandler message={props.success} />
    </Box>
  );
};

export default UserPanel;
